import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import {SvgIconProps} from '@mui/material';

import type {DepartmentHealthActionType} from '../../types/DepartmentHealthTypes';

const iconSx: SvgIconProps['sx'] = {fontSize: 15};

export const getDepartmentHealthActionSectionIcon = () => <ArrowForwardOutlinedIcon sx={{fontSize: 15}} />;

export const getDepartmentHealthActionItemIcon = (actionType: DepartmentHealthActionType) => {
  switch (actionType) {
    case 'skill_training':
      return <SchoolOutlinedIcon sx={iconSx} />;
    case 'single_point_of_failure':
      return <WarningAmberOutlinedIcon sx={iconSx} />;
    case 'redeployment_review':
      return <SwapHorizOutlinedIcon sx={iconSx} />;
    case 'development_plans':
      return <TrendingUpOutlinedIcon sx={iconSx} />;
    case 'data_quality':
      return <AccessTimeOutlinedIcon sx={iconSx} />;
    case 'all_clear':
      return <CheckCircleOutlineIcon sx={iconSx} />;
    default:
      return <CheckCircleOutlineIcon sx={iconSx} />;
  }
};
